module.exports = __webpack_public_path__ + "media/SelectNew.002f01d3.wav";